import { render } from "./SupplierAccountsData.vue?vue&type=template&id=03cb4429&scoped=true"
import script from "./SupplierAccountsData.vue?vue&type=script&lang=js"
export * from "./SupplierAccountsData.vue?vue&type=script&lang=js"

import "./SupplierAccountsData.vue?vue&type=style&index=0&id=03cb4429&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cb4429"]])

export default __exports__